import React, { useEffect } from 'react';
import styles from './Toast.module.css';

function Toast({ message, type = 'success', onClose, duration = 4000 }) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={`${styles.toast} ${styles[type]}`}>
      <span className={styles.message}>{message}</span>
      <button className={styles.close} onClick={onClose}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}

function ToastContainer({ toasts, onClose }) {
  return (
    <div className={styles.container}>
      {toasts.map((t, i) => (
        <Toast key={i} message={t.message} type={t.type} onClose={() => onClose(i)} />
      ))}
    </div>
  );
}

export { Toast, ToastContainer };
